import { CMSResource } from "app/resources/cmsresource";
import { FooterBarLinkResource } from "app/models/FooterBarLinkResource";

export class FooterBarLinkListResource extends CMSResource {
    footerBarLinkListResource: FooterBarLinkResource[];
}